/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_api_keys_wizard_publishable_key_hint = /** @type {(inputs: {}) => string} */ () => {
	return `Segura para código del lado del cliente y solicitudes del navegador.`
};

const en_developer_api_keys_wizard_publishable_key_hint = /** @type {(inputs: {}) => string} */ () => {
	return `Safe for client-side code and browser requests.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_api_keys_wizard_publishable_key_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_api_keys_wizard_publishable_key_hint(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_api_keys_wizard_publishable_key_hint", locale)
	if (locale === "es") return es_developer_api_keys_wizard_publishable_key_hint(inputs)
	return en_developer_api_keys_wizard_publishable_key_hint(inputs)
};
export { developer_api_keys_wizard_publishable_key_hint as "developer.api_keys.wizard.publishable_key_hint" }